import { apiUrl2 } from '../../settings'

export const getUniversityWiseReportUrl = () => {
  return apiUrl2 + '/api/public-college-reports'
}
